module.exports = __webpack_public_path__ + "img/IMG_1627.88934d64.jpeg";